import styled from 'styled-components';
import Split from 'react-split';

export const ResizableColumnsContainer = styled(Split)`
  height: 100%;
  display: flex;
  flex-direction: row;

  & .gutter.gutter-horizontal {
    cursor: col-resize;
    background: ${({ theme }) => theme.freecode.headerBackground};
    :hover {
      background: ${({ theme }) => theme.freecode.activeAreaColor};
    }
  }
`;

export const ColumnContainer = styled.div`
  overflow: hidden;
  height: 100%;
  width: 100%;
`;
